import { StatusEnum } from 'constants/status';
import { COLOR_PALETTE } from 'constants/ui';

const baseChipStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  flexShrink: 0,
  width: 'fit-content',
  gap: 0.75,
  paddingX: 1,
  paddingY: 0.25,
  borderRadius: 999,
  fontSize: 12,
  fontWeight: 600,
  lineHeight: '16px',
  whiteSpace: 'nowrap',
  textTransform: 'uppercase',
  letterSpacing: '0.04em',
};

const TONE_TINTS = {
  [StatusEnum.SUCCESS]: {
    backgroundColor: COLOR_PALETTE.GREEN[2],
    color: COLOR_PALETTE.GREEN[7],
  },
  [StatusEnum.ERROR]: {
    backgroundColor: COLOR_PALETTE.RED[2],
    color: COLOR_PALETTE.RED[7],
  },
  [StatusEnum.WARNING]: {
    backgroundColor: COLOR_PALETTE.ORANGE[2],
    color: COLOR_PALETTE.ORANGE[7],
  },
  [StatusEnum.IN_PROGRESS]: {
    backgroundColor: COLOR_PALETTE.BLUE[2],
    color: COLOR_PALETTE.BLUE[7],
  },
};

const DEFAULT_TINT = {
  backgroundColor: ({ palette }) => palette.background.disabled,
  color: ({ palette }) => palette.text.dark,
};

export const getChipStyles = tone => ({
  ...baseChipStyles,
  ...(TONE_TINTS[tone] ?? DEFAULT_TINT),
});
